import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";

interface CountdownModalProps {
  createTime: string; // ISO格式的时间字符串
  onComplete: () => void;
  onCancel: () => void;
}

export function CountdownModal({ createTime, onComplete, onCancel }: CountdownModalProps) {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0 });
  const navigate = useNavigate();

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const create = new Date(createTime).getTime();
      const fiveDays = 5 * 24 * 60 * 60 * 1000; // 5天的毫秒数
      const deadline = create + fiveDays;
      const diff = deadline - now;

      if (diff <= 0) {
        setTimeLeft({ hours: 0, minutes: 0 });
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      setTimeLeft({ hours, minutes });
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 60000); // 每分钟更新一次

    return () => clearInterval(interval);
  }, [createTime]);

  return (
    <>
      {/* 弹窗 */}
      <div 
        className="fixed inset-0 flex items-center justify-center z-[100] p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="countdown-modal-content bg-white rounded-lg shadow-2xl max-w-md w-full p-6 relative border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">
            账号完善提醒
          </h3>
          <p className="text-gray-600 text-center mb-6">
            您需要在注册之日起的5日内完善您的信息（还剩
            <span className="text-[#003c8c] font-bold mx-1">
              {timeLeft.hours}小时{timeLeft.minutes}分钟
            </span>
            ）才能成为正式账号，否则账号将被删除！
          </p>
          <div className="flex justify-center gap-4">
            <Button
              onClick={() => {
                navigate('/complete-info');
                onComplete();
              }}
              className="bg-[#003c8c] hover:bg-[#0050b8] text-white"
            >
              立即完善信息
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                navigate('/');
                onCancel();
              }}
              className="border-[#003c8c] text-[#003c8c] hover:bg-blue-50"
            >
              取消
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

















